import React, { useState, useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import Select from 'react-select';
import { useTranslation } from "react-i18next";

const AddStoreModal = ({ addNewStoreLink, listOfStoreLinks }) => {
  const { t } = useTranslation();
  const [modal, setModal] = useState(false);
  const [store, setStore] = useState(null);

  const toggle = () => {
    setModal(!modal);
    setStore(null);
  }

  const storeOptions = useMemo(() => {
    const usedStoreValues = new Set(listOfStoreLinks.map(link => link.store.value));

    return [
      {
        label: t("musicLinks.storeLinksRow.model.addStore.option.mainStores"),
        options: [
          { value: "amazonmusic", label: "Amazon Music" },
          { value: "applemusic", label: "Apple Music" },
          { value: "beatport", label: "Beatport" },
          { value: "deezer", label: "Deezer" },
          { value: "junodownload", label: "Junodownload" },
          { value: "soundcloud", label: "Soundcloud" },
          { value: "spotify", label: "Spotify" },
          { value: "tidal", label: "Tidal" },
          { value: "traxsource", label: "Traxsource" },
          { value: "youtube", label: "YouTube" },
        ]
      },
      {
        label: t("musicLinks.storeLinksRow.model.addStore.option.otherStores"),
        options: [
          { value: "anghami", label: "Anghami" },
          { value: "bandcamp", label: "Bandcamp" },
          { value: "boomplay", label: "Boomplay" },
          { value: "iheartradio", label: "iHeartRadio" },
          { value: "jiosaavn", label: "JioSaavn" },
          { value: "sevendigital", label: "7digital" },
        ]
      }
    ].map(group => ({
      ...group,
      options: group.options.map(option => ({
        ...option,
        isDisabled: usedStoreValues.has(option.value)
      }))
    }));
  }, [listOfStoreLinks, t]);

  return (
    <>
      <Button color="primary" onClick={toggle}>
        {t("musicLinks.storeLinksRow.model.addStore.button.add")}
      </Button>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{t("musicLinks.storeLinksRow.model.addStore.header")}</ModalHeader>
        <ModalBody>
          {t("musicLinks.storeLinksRow.model.addStore.body")}
          <Select
            className="mt-4"
            options={storeOptions}
            value={store}
            onChange={(selectedOption) => setStore(selectedOption)}
            getOptionLabel={option => option.label}
            getOptionValue={option => option.value}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={toggle}>
            {t("musicLinks.storeLinksRow.model.addStore.button.cancel")}
          </Button>
          <Button
            color="success"
            onClick={() => {
              addNewStoreLink(store);
              toggle();
            }}
            disabled={!store}
          >
            {t("musicLinks.storeLinksRow.model.addStore.button.add")}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AddStoreModal;